<img [src]="filename | fileExtension | fileIcon" />
